import omit from "lodash/omit";

import { RegisterFormRequest, RegisterFormType } from "./types";

export const normalizeRegistrationData = (data: RegisterFormType): RegisterFormRequest => omit(data, "confirmPassword");
